import React, {useState, useEffect} from 'react';

const EcxDatatable = (props) => {
    const [originalData, setOriginalData] = useState([]);
    const [data, setData] = useState([]);
    const [columns, setColumns] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchText,setSearchTect] = useState('');

    useEffect(() => {
        setData(props.data);
        setOriginalData(props.data);
        setColumns(props.columns);
        setLoading(false);
    }, [props.data, props.columns]);
    
    const handleSearch = (e) => {
        setSearchTect(e.target.value);
        console.log(e.target.value);
        const filteredData = originalData.filter(item => {
            for (let key in item) {
                if (
                    typeof item[key] === "string" &&
                    item[key].toLowerCase().includes(e.target.value.toLowerCase())
                )
                    return item;
            }
        });
        setData(filteredData);
    }
    return ( 
        <>
            <div className="row mb-2">
                <div className="col-8">
                    
                </div>
                <div className="col-4">
                   {/* pagination */}
                   <input type="text" className="form-control" placeholder="Search" onChange={handleSearch}/>
                </div>

            </div>
            {loading ? <div>Loading...</div> :
            <table className="table table-striped">
                <thead>
                    <tr>
                        {columns.map((column, index) => {
                            return <th key={index}>{column.name}</th>
                        })}
                    </tr>
                </thead>
                <tbody>
                    {data.map((row, index) => {
                        return <tr key={index}>
                            {columns.map((column, index) => {
                                return <td key={index}>{column.selector(row)}</td>
                            })}
                        </tr>
                    })}
                </tbody>
            </table>
            }

        </>
     );
}
 
export default EcxDatatable;